<template>
  <div>
    <div @click="showAsyncPicker" :light="true" class="wmq-cascade" :class="colorClass">
      <div class="display-style">{{ showLabel ? showLabel : placeholder }}</div>
      <div v-if="showLabel && !disabled && clearable" class="sprite icon-close wmq-cascade-clear" style="width: 10%;" @click="reset"></div>
    </div>
    <van-popup v-model="show" round position="bottom" class="wmq-select-popup">
      <van-picker
        :title="placeholder"
        :columns="filteredOptions"
        @confirm="onConfirm"
        show-toolbar
        :default-index="defaultIndex"
        @cancel="show = false"
      >
        <van-search v-if="isSearch" slot="columns-top" v-model="searchValue" @input="remote" placeholder="请输入搜索关键词" />
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import request from '@/utils/request'
import { isEmpty } from 'lodash'
export default {
  name: 'Select',
  props: {
    value: {
      type: [String, Array],
      default() {
        return undefined
      }
    },
    fontSizeClass: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    optionSource: {
      type: Object,
      default() {
        return {}
      }
    },
    options: {
      type: Array,
      default() {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isSearch: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      asyncData: [],
      selectedText: '',
      show: false,
      searchValue: undefined,
      defaultIndex: 0,
      allOptions: [] // 保存所有选项，用于本地搜索
    }
  },
  computed: {
    colorClass() {
      return this.isEmptyValue(this.value) ? 'color-gray' : 'color-black'
    },
    fontClass() {
      return this.fontSizeClass ? 'font-bold' : ''
    },
    showLabel() {
      return this.selectedText
    },
    // 过滤后的选项列表（用于本地搜索）
    filteredOptions() {
      if (!this.isSearch || !this.searchValue || this.searchValue.trim() === '') {
        return this.options
      }
      const keyword = this.searchValue.trim().toLowerCase()
      return this.options.filter(option => {
        const text = (option.text || '').toLowerCase()
        const value = (option.value || '').toLowerCase()
        return text.includes(keyword) || value.includes(keyword)
      })
    }
  },
  mounted () {
    if (!isEmpty(this.optionSource)) {
      request({
        url: this.optionSource.path,
        method: 'get'
      }).then(res => {
        this.asyncData = res.data.items
      })
    } else {
      this.asyncData = this.options
    }
    this.resetIndex(this.value)
  },
  watch: {
    value(val) {
      if (this.isEmptyValue(val)) {
        this.selectedText = ''
        this.defaultIndex = 0
      } else {
        this.resetIndex(val)
      }
    },
    options() {
      if (!this.value) {
        this.selectedText = ''
      } else {
        this.resetIndex(this.value)
      }
    }
  },
  methods: {
    isEmptyValue(val) {
      return val == null || val === '' || (Array.isArray(val) && val.length === 0)
    },
    resetIndex(val) {
      if (this.isEmptyValue(val)) {
        this.selectedText = ''
        this.defaultIndex = 0
        return
      }
      const index = this.options.findIndex(item => item.value === val)
      if (index > -1) {
        this.selectedText = this.options[index].text
        this.defaultIndex = index
      } else {
        this.defaultIndex = 0
      }
    },
    reset(e) {
      this.selectedText = ''
      this.defaultIndex = 0
      this.$emit('updateValue', undefined)
      this.$emit('remoteHandle', '')
      e.stopPropagation()
    },
    onConfirm(value, index) {
      this.selectedText = value.text
      this.$emit('updateValue', value.value)
      this.show = false
    },
    showAsyncPicker() {
      if (this.disabled) {
        return
      }
      // 重置搜索关键词
      this.searchValue = undefined
      this.resetIndex(this.value)
      this.show = true
    },
    setSelectedText(data) {
      console.log('setSelectedText', data)
      this.selectedText = data
    },
    remote(value) {
      this.$emit('remoteHandle', value)
    }
  }
}
</script>

<style lang="stylus" scoped>
.wmq-cascade{
    text-align: left;
    font-size: 28px;
    background-color: #fff;
    border: 1px solid #eee;
    width: 100%;
    display: flex;
    position: relative;
    min-height: 40px;
    height: auto;
    padding: 8px 10px;
    align-items: center;
}
.wmq-cascade-clear{
    height: 42px;
    width: 42px;
    line-height: 60px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}
.display-style{
    white-space: normal;
    word-break: break-all;
    line-height: 1.5;
    width: 90%;
    font-size: 28px;
}
.color-gray{
    color: #64748b !important
}
.color-black{
    color: #1e293b !important
}
.font-bold{
    font-size: 24px;
}
.cube-validator_invalid .van-popup {
  color: #666 !important
}
</style>

<style lang="stylus">
/* van-popup 挂载到 body，需全局样式 */
.wmq-select-popup
  .van-picker__toolbar
    height 88px

  .van-picker__cancel,
  .van-picker__confirm
    font-size 28px
    padding 0 32px

  .van-picker__title
    font-size 32px
    font-weight 500
    line-height 88px
    max-width 60%

  .van-picker-column__item
    font-size 28px
    color #1e293b
    padding 0 24px

  .van-search
    padding 16px 24px

    .van-search__content
      display flex
      align-items center
      min-height 72px
      padding-left 0
      padding-right 0
      background-color #f7f8fa
      .van-icon-search{
        font-size 28px
        }
        .van-field__body{
            width 100%
            .van-icon{
                    font-size 28px
                }
            }

    .van-cell
      display flex
      align-items center
      font-size 28px
      line-height 40px
      padding 0
      background-color transparent

    .van-field__left-icon
      display flex
      align-items center
      height 40px
      margin-right 8px
      line-height 1

    .van-field__body
      display flex
      align-items center

    .van-cell__value
      display flex
      align-items center

    .van-field__control
      font-size 28px
      line-height 40px
      height 40px

    .van-field__control::placeholder
      font-size 28px
      color #64748b
      line-height 40px
</style>
